<mat-card>
  <mat-card-content>
    <form [formGroup]="companyBranchForm" class="fx-row fx-align-space-between-start">
      <mat-form-field class="margin fx-flex-gt-md" appearance="fill">
        <mat-label>Company</mat-label>
        <mat-select formControlName="companyId" placeholder="select company">
          <mat-option>
            <ngx-mat-select-search  [searching]="searching" [formControl]="companyCtrl"
              noEntriesFoundLabel="'no matching found'" placeholderLabel="Search Company">
              <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
            </ngx-mat-select-search>
          </mat-option>
          @if (role==='ROLE_GSA') {
            <mat-option [value] = "null">None</mat-option>
          }
          @for (com of filteredCompany|async; track com) {
            <mat-option [disabled] ="com.isCompanyDeactivated" [value]="com.companyId">
              {{com.name}} ({{com.code}})
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="margin fx-flex-gt-md" appearance="fill">
        <mat-label>Branch</mat-label>
        <mat-select formControlName="branchId" placeholder="select branch">
          <mat-option>
            <ngx-mat-select-search  [searching]="searching" [formControl]="branchCtrl"
              noEntriesFoundLabel="'no matching found'" placeholderLabel="Search Branch">
              <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
            </ngx-mat-select-search>
          </mat-option>
          <mat-option [value] = null>None</mat-option>
          @for (br of filteredBranch|async; track br) {
            <mat-option [disabled] ="br.isBranchDeactivated" [value]="br.branchId">
              {{br.name}} ({{br.code}})
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <button  mat-button color="primary" (click)="onChange()">CHANGE</button>
    <button  mat-button color="cancel" (click)="onCancel()">CANCEL</button>
  </mat-card-actions>
</mat-card>
